import { Component } from "react";
import SearchVehiclesContext from "../SearchVehiclesContext";
import Box from '@mui/material/Box';
import { Trans } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import CancelIcon from '@mui/icons-material/Cancel';
import Divider from '@mui/material/Divider';

type Props = {
  open: boolean,
  handleClose: any
}

export const NotFoundUnitDialog = (props: Props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      className="unit-404-dialog"
    >
      <Box>
        <Box sx={{margin: '0 9%'}}>
          <Box sx={{display: 'flex', margin: '32px 0 0'}}>
            <CancelIcon className="unit-404-dialog-icon" sx={{marginRight: '12px'}}/>
            <Box className="unit-404-dialog-title"><Trans i18nKey={`screens.notFoundUnitDialog.title`}></Trans></Box>
          </Box>
          <Box className="unit-404-dialog-text" sx={{marginTop: '18px'}}><Trans i18nKey={`screens.notFoundUnitDialog.text1`}></Trans></Box>
          <li className="unit-404-dialog-text"><Trans i18nKey={`screens.notFoundUnitDialog.item1`}></Trans></li>
          <li className="unit-404-dialog-text"><Trans i18nKey={`screens.notFoundUnitDialog.item2`}></Trans></li>
          <Box className="unit-404-dialog-text" sx={{marginBottom: '18px'}}><Trans i18nKey={`screens.notFoundUnitDialog.text2`}></Trans></Box>
        </Box>
        <Divider/>
        <Box sx={{display: 'flex', justifyContent: 'space-around', margin: '12px 9%'}}>
          <Button onClick={props.handleClose} className="unit-404-dialog-success-button">
              <Trans i18nKey={`screens.notFoundUnitDialog.successButton`}></Trans>
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

export default class extends Component {
  render = () => 
  <SearchVehiclesContext.Consumer>
    { context => {
      const handleClose = () => {
        context.open = false
        context.refresh()
    }
      return (
        <NotFoundUnitDialog open={context.open} handleClose={handleClose}/>
      )
    }}
  </SearchVehiclesContext.Consumer>
}